import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=45dd8dec&scoped=true&"
import script from "./ModalFooter.vue?vue&type=script&lang=js&"
export * from "./ModalFooter.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/modal_footer.scss?vue&type=style&index=0&id=45dd8dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd8dec",
  null
  
)

export default component.exports